import { Typography } from '@repo/ui';
import styles from './BetaTag.module.css';

export const BetaTag = () => {
  return (
    <Typography variant='chart-label' className={styles.tag}>
      BETA
    </Typography>
  );
};
